import { ReadonlyFieldArrow } from '@/forms-legacy'
import { Cross, Plus } from '@/icons'
import { memo } from 'react'

import BaseBtn from './BaseBtn'
import IconContainer from './IconContainer'
import TextContainer from './TextContainer'
import { Props } from './typings'

export function TagListItemComponent(props: Props) {
  const { children, onClick, disabled, uiStyle, trackId } = props

  return (
    <BaseBtn
      onClick={onClick}
      disabled={disabled}
      style={{ padding: 0 }}
      data-testid="tags__base-button"
      data-trackid={trackId}
    >
      <ReadonlyFieldArrow style={{ width: '98%', flexWrap: 'nowrap' }}>
        <IconContainer uiStyle={uiStyle} style={{ flex: '0 0 auto' }}>
          {uiStyle === 'remove' ? <Cross color="$outrageousRed" /> : <Plus color="$pigmentGreen" />}
        </IconContainer>
        <TextContainer>{children}</TextContainer>
      </ReadonlyFieldArrow>
    </BaseBtn>
  )
}

export const TagListItem = memo(TagListItemComponent)
